import { gql } from '@apollo/client';

export type UspsProcessStatus = 'PENDING' | 'SUCCESS' | 'FAILED';

export interface UspsAddressProcessType {
  id: string;
  originalAddress: string;
  uspsAddress?: string | null;
  orderAddressId: number;
  processStatus: UspsProcessStatus;
  uspsApiResultJson?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
}

export interface UspsAddressProcessPageResponse {
  content: UspsAddressProcessType[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
}

export interface GetUspsAddressProcessListResponse {
  uspsAddressProcessList: UspsAddressProcessPageResponse;
}

export interface CreateUspsAddressProcessInput {
  orderAddressId: number;
  originalAddress: string;
}

export const GET_USPS_ADDRESS_PROCESS_LIST = gql`
  query GetUspsAddressProcessList(
    $processStatus: UspsProcessStatusType
    $orderAddressId: Long
    $originalAddress: String
    $createdAtFrom: String
    $createdAtTo: String
    $page: Int!
    $size: Int!
  ) {
    uspsAddressProcessList(
      processStatus: $processStatus
      orderAddressId: $orderAddressId
      originalAddress: $originalAddress
      createdAtFrom: $createdAtFrom
      createdAtTo: $createdAtTo
      page: $page
      size: $size
    ) {
      content {
        id
        originalAddress
        uspsAddress
        orderAddressId
        processStatus
        uspsApiResultJson
        createdAt
        updatedAt
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;

export const CREATE_USPS_ADDRESS_PROCESS = gql`
  mutation CreateUspsAddressProcess($input: CreateUspsAddressProcessInput!) {
    createUspsAddressProcess(input: $input) {
      id
      orderAddressId
      originalAddress
      processStatus
      createdAt
    }
  }
`;

export const DELETE_USPS_ADDRESS_PROCESS = gql`
  mutation DeleteUspsAddressProcess($id: Long!) {
    deleteUspsAddressProcess(id: $id)
  }
`;

export const BATCH_DELETE_USPS_ADDRESS_PROCESS = gql`
  mutation BatchDeleteUspsAddressProcess($ids: [Long!]!) {
    batchDeleteUspsAddressProcess(ids: $ids)
  }
`;
